<mojo-navbar></mojo-navbar>
<div style="margin-left:1em;">
  <h1>Invalid URL</h1>
  <h3>The URL <strong>{{previouslyRequestedUrl}}</strong> is invalid.</h3>
  <h4>(Either the URL does not exist, or your current user's limited access configuration
  doesn't allow access to it.)</h4>
</div>
